export function mapScoreToLabel(score: number): { label: string; range: string } {
  if (score >= 90) return { label: "Muy bien", range: "90 a 100" };
  if (score >= 80) return { label: "Regular", range: "80 a 89" };
  return { label: "No aprobatorio", range: "0 a 79" };
}
